var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9d018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2106,
    stopColor: "#97d02a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#27d045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#278c45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.11847,44.0274l3.84924-3.84924,2.81622-2.81622,1.72589-1.72589c.77374-.77338.77374-2.02765,0-2.80103-.77374-.77374-2.02722-.77374-2.80096,0l-1.49268,1.49261-2.46301,2.46283h0l-3.03522,3.0351-3.11902-3.11865c-.77374-.77295-2.02722-.77338-2.80096.00043-.7738.77332-.7738,2.02759,0,2.80133l4.51947,4.51917c.3869.38647.89368.5799,1.40051.5799s1.01361-.19342,1.40051-.58032Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.61804,44.55902c0-.38226-2.14062-5.81018-2.67578-6.03955-.83679-.11768-1.68604-.11768-2.52289,0-1.5766,1.09399-2.65027,2.77319-2.98151,4.66339-.38226,2.98157,1.45258,6.03955,1.45258,6.03955,1.86115,2.76904,4.0708,5.28705,6.57465,7.49207,2.19025,1.73315,4.67688,3.0542,7.33917,3.89899,1.55292.61993,3.25165.7793,4.89276.45868,1.45465-.39935,2.74152-1.2572,3.66968-2.44635.21741-.54108.37134-1.10541.45862-1.68201.08752-.50586.08752-1.02307,0-1.52893-.07648-.5351-5.58087-3.05804-6.11597-2.90509-.53516.15289-.9939,1.14673-1.60541,1.98767-.61157.84094-.84094,1.22327-1.45258,1.22327-.61169,0-3.28735-1.07031-5.81018-3.36377-1.44098-1.24945-2.56726-2.82098-3.28741-4.58704,0,0,.45868-.5351,1.07037-1.37616.47595-.52136.81708-1.15131.9939-1.83472Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.54645,44.25629c.45074,1.67676.71356,3.42975.71356,5.24689,0,11.17181-9.0882,20.26001-20.26001,20.26001-11.17053,0-20.25873-9.0882-20.25873-20.26001s9.0882-20.26001,20.25873-20.26001c4.92108,0,9.43506,1.76654,12.94891,4.6947l2.70868-2.7085c-4.21375-3.61572-9.68292-5.80786-15.65759-5.80786-13.27844,0-24.08167,10.80322-24.08167,24.08167,0,4.72913,1.38977,9.1311,3.75421,12.85602l-3.44843,12.2193,12.92004-3.59314.00244-.01428c3.26611,1.6582,6.94672,2.61377,10.85339,2.61377,13.27844,0,24.08167-10.80322,24.08167-24.08167,0-2.91742-.52228-5.71497-1.47699-8.30511l-3.05823,3.05823Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappChecker);
export default __webpack_public_path__ + "static/media/whatsapp-checker.9cd90983b3b98c8ed1fb7472bc4372f4.svg";
export { ForwardRef as ReactComponent };